import React from "react";

export const Packing = ({ color = "white" }) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.33334 14.6673C6.78801 14.6673 6.26668 14.4473 5.22468 14.0073C2.63068 12.9113 1.33334 12.3627 1.33334 11.4407V4.66732M7.33334 14.6673V7.57065M7.33334 14.6673C7.81668 14.6673 8.19534 14.494 9.00001 14.1493M13.3333 4.66732V7.33398M10 11.6673H14.6667M12.3333 14.0007V9.33398M3.33334 8.00065L4.66668 8.66732M10.6667 2.66732L4.00001 6.00065M4.88401 6.46132L2.93668 5.51932C1.86801 5.00198 1.33334 4.74332 1.33334 4.33398C1.33334 3.92465 1.86801 3.66598 2.93668 3.14865L4.88334 2.20665C6.08668 1.62465 6.68668 1.33398 7.33334 1.33398C7.98001 1.33398 8.58068 1.62465 9.78268 2.20665L11.73 3.14865C12.7987 3.66598 13.3333 3.92465 13.3333 4.33398C13.3333 4.74332 12.7987 5.00198 11.73 5.51932L9.78334 6.46132C8.58001 7.04332 7.98001 7.33398 7.33334 7.33398C6.68668 7.33398 6.08601 7.04332 4.88401 6.46132Z"
        stroke={color}
      />
    </svg>
  );
};
